/**
 * 捐赠记录 — GET /api/admin/donations
 *
 * Cross-user paginated donation history. Operators can filter by `donor_id`
 * or `cause_id` to audit a single donor's giving history or see who gave to
 * a specific campaign. All rows are immutable — there is no edit/delete UI.
 */
import { useState } from 'react';
import { Input, Space, Tag } from 'antd';
import { DataTable } from '../../components/DataTable';

interface DonationRow {
  id: string;
  donor_id: number;
  cause_id: number;
  cause_code: string | null;
  cause_title_zh: string | null;
  asset: string;
  amount: string;
  note: string | null;
  donation_level: number;
  create_time: string;
}

export function DonationLogPage() {
  const [donorId, setDonorId] = useState<string>('');
  const [causeId, setCauseId] = useState<string>('');

  const columns = [
    { title: '记录 ID', dataIndex: 'id', width: 110 },
    { title: '捐赠人', dataIndex: 'donor_id', width: 100 },
    { title: '项目 ID', dataIndex: 'cause_id', width: 100 },
    {
      title: '项目 Code',
      dataIndex: 'cause_code',
      width: 160,
      render: (v: string | null) => v ?? '—',
    },
    {
      title: '项目标题',
      dataIndex: 'cause_title_zh',
      width: 200,
      ellipsis: true,
      render: (v: string | null) => v ?? '—',
    },
    {
      title: '资产',
      dataIndex: 'asset',
      width: 80,
      render: (v: string) => <Tag>{v.toUpperCase()}</Tag>,
    },
    { title: '金额', dataIndex: 'amount', width: 160 },
    {
      title: '捐赠等级',
      dataIndex: 'donation_level',
      width: 100,
      render: (v: number) => <Tag color="gold">Lv.{v}</Tag>,
    },
    {
      title: '留言',
      dataIndex: 'note',
      width: 200,
      ellipsis: true,
      render: (v: string | null) => v ?? '—',
    },
    { title: '时间', dataIndex: 'create_time', width: 170 },
  ];

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>捐赠记录</h2>
      <Space style={{ marginBottom: 12 }} wrap>
        <Input
          placeholder="按捐赠人 ID"
          style={{ width: 160 }}
          allowClear
          value={donorId}
          onChange={(e) => setDonorId(e.target.value)}
        />
        <Input
          placeholder="按项目 ID"
          style={{ width: 160 }}
          allowClear
          value={causeId}
          onChange={(e) => setCauseId(e.target.value)}
        />
      </Space>
      <DataTable<DonationRow>
        queryKey={['admin', 'donation-log', donorId, causeId]}
        endpoint="/api/admin/donations"
        extraParams={{
          donor_id: donorId ? Number(donorId) : undefined,
          cause_id: causeId ? Number(causeId) : undefined,
        }}
        columns={columns}
        rowKey="id"
        scroll={{ x: 1600 }}
      />
    </div>
  );
}
